<template>
	<div class="text-xs leading-4.5" v-html="$t('foot_note.captchaText')"></div>
	<!-- https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge.-what-is-allowed -->
</template>
